// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"21528fbda1103b095489","453":"f0ed1cdd99ee58f84fee"}[chunkId] + ".js";
};